export default {
  get groups () {
    return [{
      name: 'Preschool',
      req: 'Ages 3-5',
      desc: 'Ages 3-5',
      classes: {
        m: [
          { title: 'Preschool ballet', start: '5:00', end: '5:30' },
          { title: 'Toddler & Me', start: '5:30', end: '6:00' }
        ],
        f: [
          { title: 'Dancing tots', start: '6:15', end: '6:45' }
        ]
      }
    }, {
      name: 'Beginner',
      req: 'Ages 5+',
      desc: 'Ages 5+',
      classes: {
        m: [
          { title: 'Hip Hop', start: '6:00', end: '6:30' },
          { title: 'Tap', start: '6:30', end: '7:00' }
        ],
        t: [
          { title: 'Lyrical 1', start: '5:00', end: '5:30' },
          { title: 'Lyrical 2', start: '5:30', end: '6:00' },
          { title: 'Contemporary 1', start: '6:45', end: '7:30' }
        ],
        w: [
          { title: 'Beginner Ballet', start: '5:00', end: '5:30' },
          { title: 'Ballet 1', start: '5:30', end: '6:00' },
          { title: 'Ballet 2', start: '6:00', end: '6:45' }
        ],
        th: [
          { title: 'Jazz 1', start: '5:15', end: '6:00' }
        ],
        f: [
          { title: 'Jazz funk', start: '5:30', end: '6:00' }
        ]
      }
    }, {
      name: 'Intermediate',
      req: 'Teacher placement',
      classes: {
        t: [
          { title: 'Contemporary 2', start: '8:00', end: '8:30' }
        ],
        w: [
          { title: 'Ballet 3', start: '7:00', end: '8:00' }
        ],
        th: [
          { title: 'Jazz 2', start: '7:00', end: '8:00' }
        ]
      }
    }, {
      name: 'Adult',
      desc: 'Ages 18+',
      classes: {
        sun: [
          { title: 'Belly dancing', start: '4:00', end: '5:00' }
        ]
      }
    }, {
      name: 'Other',
      classes: {
        m: [
          { title: 'FREE Stretch & Conditioning', desc: 'All ages', start: '7:00', end: '7:30' }
        ],
        t: [
          { title: 'Leaps and Turns', start: '6:15', end: '6:45' }
        ],
        th: [
          { title: 'Stretch', start: '6:15', end: '6:30' },
          { title: 'Turns and leaps', start: '6:30', end: '7:00' }
        ],
        f: [
          { title: 'Tumbling', start: '5:00', end: '5:30' }
        ]
      }
    }]
  }
}
